import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { organisationTabCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_MOBILE_DEVICES_SUMMARYCARD,
  FETCH_MOBILE_DEVICES_SUMMARYCARD_ERROR,
  SET_MOBILE_DEVICES_SUMMARYCARD
} from '../../constants';

const mobileDevicesSummary = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_MOBILE_DEVICES_SUMMARYCARD),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/mobile-devices/summary?${
          organisationTabCriteria(state$)
        }${
          boundariesCriteria(state$)
        }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {

          return {
            type: SET_MOBILE_DEVICES_SUMMARYCARD,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_MOBILE_DEVICES_SUMMARYCARD_ERROR,
            error,
          })
        )
      )
    )
  );

export default mobileDevicesSummary;
